import { useEffect, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { login, userManager } from './userManager';

/** Пускает дальше только с действующей сессией Keycloak, иначе — на страницу входа. */
export function AuthGate({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      let user = await userManager.getUser();
      if (user?.expired) user = await userManager.signinSilent().catch(() => null);
      if (!alive) return;
      if (!user) {
        await login().catch(() => setError(t('auth.unavailable')));
        return;
      }
      setReady(true);
    })();
    const onSignedOut = () => void login();
    userManager.events.addUserSignedOut(onSignedOut);
    userManager.events.addSilentRenewError(() => undefined);
    return () => {
      alive = false;
      userManager.events.removeUserSignedOut(onSignedOut);
    };
  }, [t]);

  if (error)
    return (
      <div className="center-screen">
        <div className="empty">
          {error}
          <br />
          <button className="btn btn-primary" onClick={() => window.location.reload()}>
            {t('common.retry')}
          </button>
        </div>
      </div>
    );
  if (!ready) return <div className="center-screen loading">{t('auth.redirecting')}</div>;
  return <>{children}</>;
}
